<script>
  import curd from './Base/Crud'
  export default {
    name: 'SurveyQuestionAnswer',
    mixins: [curd],
    props: ['defaultParams'],
    data() {
      return {
        url: '/survey/question/answer',
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: false, // 增加按钮显隐
          addBtnText: '新增项目', // 新增按钮文案
          editBtn: false, // 修改按钮显隐
          delBtn: false, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中x
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '用户',
              prop: 'user-username',
              span: 24,
            },
            {
              label: '所属部门',
              prop: 'user-class',
              span: 24,
            },
            {
              label: '答题内容',
              overHidden: true,
              prop: 'answer',
              type: 'textarea',
              align: 'left',
              span: 24
            }
          ]
        }
      }
    }
  }
</script>
